module.exports = __webpack_public_path__ + "static/img/10.b77ff94.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/10.png
// module id = Ctls
// module chunks = 3